import React from "react";
import { Link } from "react-router-dom";
import { Link as RLink } from "react-router-dom";

export function GoldRule({ className = "" }) {
  return <span className={`inline-block h-[2px] w-10 bg-ei-gold ${className}`} aria-hidden="true" />;
}

export function Eyebrow({ children, className = "" }) {
  return <div className={`ei-eyebrow ${className}`}>{children}</div>;
}

export function PrimaryLink({ to, children, testId, className = "" }) {
  return (
    <Link
      to={to}
      data-testid={testId}
      className={`font-display text-sm font-bold bg-ei-navy text-ei-white px-6 py-3.5 rounded-sm hover:bg-ei-ink transition-colors inline-flex items-center justify-center min-h-[44px] ${className}`}
    >
      {children}
    </Link>
  );
}

export function GhostLink({ to, children, testId, className = "" }) {
  return (
    <Link
      to={to}
      data-testid={testId}
      className={`font-display text-sm font-bold text-ei-navy border border-ei-navy/25 px-6 py-3.5 rounded-sm hover:border-ei-navy hover:bg-ei-navy/[0.03] transition-colors inline-flex items-center justify-center min-h-[44px] ${className}`}
    >
      {children}
    </Link>
  );
}

export function SectionHeading({ eyebrow, title, intro, center = false }) {
  return (
    <div className={`${center ? "text-center mx-auto" : ""} max-w-2xl`}>
      {eyebrow && <Eyebrow className={center ? "flex items-center justify-center gap-3" : ""}>{eyebrow}</Eyebrow>}
      <h2 className="mt-4 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-ei-navy">{title}</h2>
      {intro && <p className="mt-4 text-base text-ei-graphite/90 leading-relaxed">{intro}</p>}
    </div>
  );
}

// Small note used to flag content that is a professional assumption / pending confirmation.
export function ReviewNote({ children }) {
  return (
    <p className="text-xs text-ei-graphite/60 leading-relaxed border-l-2 border-ei-gold/60 pl-3">
      {children}
    </p>
  );
}
